module.exports = __webpack_public_path__ + "img/121.0a73a4fe.png";